<template>
  <a-card :bordered="false">
    <!-- 検索区域-begin -->
    <search-area
      ref="SearchArea"
      :rowKeySize="this.selectedRowKeys.length"
      batchType="1"
      parent="RuntimeModal"
      @searchQuery="searchQuery(false, false)"
      @updateQueryParam="updateQueryParam"
      @batchAction="batchAction"
    ></search-area>
    <!-- 検索区域-end -->

    <!-- table区域-begin -->
    <div>
      <a-alert type="warning" show-icon style="margin-bottom: 10px" class="animate__animated animate__flipInX_disable">
        <template slot="message">
          <span>自行</span>
          <span style="color: var(--color-orange)"> 撤回 </span>
          <span>或者被 </span>
          <span style="color: var(--color-red)"> 驳回 </span>
          <span>的流程，可以在 </span>
          <a
            class="annotate1"
            style="color: var(--color-primary); line-height: 20px; display: inline-block; padding: 0 5px"
            @click="
              $router.push({
                name: 'k00-k0011-TaskManage',
              })
            "
            >待办流程</a
          >
          <span> 中找到并且编辑之后再次申请，</span>
          <span class="annotate2" style="color: var(--color-red)">不必重新发起新的流程 !!!</span>

          <div style="float: right">
            <span style="margin-right: 8px">仅显示我发起的</span>
            <a-switch size="small" v-model="queryParam.showOnlyMe" style="position: relative; top: -1px" />
          </div>
        </template>
      </a-alert>

      <a-table
        ref="table"
        class="action"
        rowKey="processInstanceId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
        tableLayout="auto"
      >
        <!-- 申請時間 -->
        <div slot="startDate" slot-scope="text, record">
          <span>
            {{ moment(record.startDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.startDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- 最近更新時間 -->
        <div slot="endDate" slot-scope="text, record">
          <span>
            {{ moment(record.endDate).format('YYYY-MM-DD') }}
          </span>
          <span class="note">
            {{ moment(record.endDate).format(' HH:mm:ss') }}
          </span>
        </div>

        <!-- タスク -->
        <div slot="task" slot-scope="text, record">
          <TaskColumn :record="record" :key="refresh"></TaskColumn>
        </div>

        <!-- 処理者 -->
        <div slot="candidate" slot-scope="text, record" class="show-title">
          <TaskColumn :record="record" colType="candidate" :key="refresh"></TaskColumn>
        </div>

        <!-- ステータス -->
        <span slot="taskStatus" slot-scope="text, record">
          <a-tag color="purple" v-if="record.taskStatus == 'disp.flow.applyWait'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="orange" v-else-if="record.taskStatus == 'disp.flow.approveWait'">{{
            $t(record.taskStatus)
          }}</a-tag>
          <a-tag color="cyan" v-else-if="record.taskStatus == 'disp.flow.keep'">{{ $t(record.taskStatus) }}</a-tag>
          <a-tag color="blue" v-else-if="record.taskStatus == 'disp.flow.freeze'">{{ $t(record.taskStatus) }}</a-tag>
        </span>

        <div slot="action" slot-scope="text, record" style="width: 100%; text-align: left">
          <div v-if="record.keepFlag || record.freezeFlag">
            <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>

            <a-divider type="vertical" />

            <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
              $t('disp.flow.history')
            }}</a>
          </div>

          <div v-else>
            <a @click="handleOperate(record)" v-if="canOperate(record)">{{ $t('disp.flow.operate') }}</a>

            <a-divider type="vertical" v-if="canOperate(record)" />

            <a v-if="record.pullbackList.length > 1" @click="openPullback(record)">{{ $t('disp.flow.pullback') }}</a>

            <a-popconfirm
              v-else-if="record.pullBackFlag || record.pullbackList.length > 0"
              :title="$t('msg.flow.confirm.pullback')"
              @confirm="() => handlePullback(record.processInstanceId, record.endDateTimestamp, record.pullbackList)"
            >
              <a>{{ $t('disp.flow.pullback') }}</a>
            </a-popconfirm>

            <a-divider v-if="record.pullBackFlag" type="vertical" />

            <a-popconfirm
              v-if="record.cancelFlag"
              :title="$t('msg.flow.confirm.cancel')"
              @confirm="() => handleCancel(record.processInstanceId, record.endDateTimestamp)"
            >
              <a>{{ $t('disp.flow.cancel') }}</a>
            </a-popconfirm>

            <a-divider v-if="record.cancelFlag" type="vertical" />

            <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>

            <a-divider type="vertical" />

            <a @click="handleHistory(record.processInstanceId, record.processDefinitionName)">{{
              $t('disp.flow.history')
            }}</a>
          </div>
        </div>
      </a-table>
    </div>
    <!-- table区域-end -->

    <track-modal ref="TrackModal"></track-modal>

    <!-- 申請モーダル：申請フォームを載せる -->
    <apply-modal ref="ApplyModal" @searchQuery="searchQuery(true, false)"></apply-modal>

    <!-- コメントモーダル：コメントフォームを載せる -->
    <comment-modal ref="CommentModal" @ok="searchQuery(false, false)"></comment-modal>

    <j-modal
      title="撤回"
      :visible="visiblePullback"
      :destroyOnClose="true"
      :centered="true"
      :width="940"
      @ok="handlePullbackOk()"
      @cancel="visiblePullback = false"
    >
      <div style="font-size: 15px; margin-top: -6px; margin-bottom: 3px; color: black">
        <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
        <span>请选择撤回节点：</span>
      </div>

      <div class="div-flow-filter">
        <template v-for="item in pullbackRecord.pullbackList">
          <div
            :key="item.taskDefinitionKey"
            class="pullbackTarget"
            :class="pullbackTaskDefinitionKey == item.taskDefinitionKey ? 'active' : ''"
            @click="pullbackTaskDefinitionKey = item.taskDefinitionKey"
          >
            <span>{{ item.name }}</span>
          </div>
        </template>
      </div>

      <div class="track-wrapper graph" v-if="pullbackRecord.processInstanceId">
        <img :src="trackSrc(pullbackRecord.processInstanceId)" />
      </div>
    </j-modal>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { flowMixin } from '@/mixins/flowMixin'
import { putAction, postAction, getAction } from '@/api/manage'
import TrackModal from './TrackModal'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import SearchArea from './SearchArea'
import CommentModal from '@/views/k00/k0011/modules/CommentModal'
import TaskColumn from '@/views/k00/k0011/modules/TaskColumn'

export default {
  name: 'RuntimeModal',
  mixins: [tableMixin, flowMixin],
  components: {
    TrackModal,
    JDictSelectTag,
    SearchArea,
    CommentModal,
    TaskColumn,
  },
  data() {
    return {
      description: '処理済一覧・進行中',
      // ログインユーザ情報
      loginUser: this.$store.getters.userInfo,
      showLoadingBySearch: true,
      refresh: Date.parse(new Date()),
      // 撤回的流程记录
      pullbackRecord: [],
      // 撤回对象节点的定义
      pullbackTaskDefinitionKey: '',
      // 撤回modal
      visiblePullback: false,
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.applyId'),
          //align: 'center',
          //width: 91,
          //fixed: 'left',
          dataIndex: 'processInstanceId',
          customRender: this.renderProcessInstanceId,
        },
        {
          title: this.renderApplyNameHeader,
          dataIndex: 'processDefinitionName',
          customRender: this.renderApplyName,
        },
        {
          title: this.$t('disp.flow.starter'),
          align: 'center',
          width: 91,
          customRender: this.renderStarter,
        },
        {
          title: this.$t('disp.flow.starterOrg'),
          align: 'left',
          // width: 180,
          dataIndex: 'starterDepartName',
          customRender: this.renderDepartName,
        },
        {
          title: this.$t('disp.flow.startDate'),
          align: 'left',
          dataIndex: 'startDate',
          //scopedSlots: { customRender: 'startDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.lastUpdateDate'),
          align: 'left',
          dataIndex: 'endDate',
          //scopedSlots: { customRender: 'endDate' },
          customRender: this.renderDate,
        },
        {
          title: this.$t('disp.flow.task'),
          scopedSlots: { customRender: 'task' },
        },
        {
          title: this.$t('disp.flow.candidate'),
          align: 'center',
          width: 91,
          //fixed: 'right',
          scopedSlots: { customRender: 'candidate' },
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 91,
          //fixed: 'right',
          scopedSlots: { customRender: 'taskStatus' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          //width: 190,
          //fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/flow/runtime/list',
        pullback: '/flow/processInstance/pullback',
        cancel: '/flow/processInstance/cancel',
      },
    }
  },
  computed: {},
  mounted() {
    var interval = setInterval(() => {
      if (!this.loading) {
        clearInterval(interval)

        setTimeout(() => {
          if (document.querySelector('.annotate1')) {
            RoughNotation.annotate(document.querySelector('.annotate1'), {
              type: 'circle',
              color: '#f5222d',
            }).show()
          }
        }, 100)

        setTimeout(() => {
          if (document.querySelector('.annotate2')) {
            RoughNotation.annotate(document.querySelector('.annotate2'), {
              type: 'underline',
              color: '#fa8c16',
            }).show()
          }
        }, 900)
      }
    }, 1)
  },
  methods: {
    updateQueryParam() {
      this.queryParam = this.$refs.SearchArea ? this.$refs.SearchArea.queryParam : {}
    },
    canOperate(record) {
      var found = false
      record.lstTask.forEach((task) => {
        if (found) {
          return false
        }

        if (task.taskActive && task.candidateUsers) {
          task.candidateUsers.forEach((candidateUser) => {
            if (found) {
              return false
            }

            if (candidateUser.id == this.loginUser.id) {
              // 会签任务的时候需要任务处于激活状态
              if (task.paralleltask || task.parallelFlag) {
                if (candidateUser.taskActive) {
                  found = true
                }
              } else {
                found = true
              }
            }
          })
        }
      })

      return found
    },
    handleOperate(record) {
      this.$approveWF(record.processInstanceId)
    },
    handleOpen(record) {
      //// 0 下記以外
      //// 1 申請ポータル
      //// 2 一時保存一覧
      //// 3 未処理一覧
      //// 4 処理済一覧・進行中案件 or 申請案件一覧・進行中案件
      //// 5 処理済一覧・終了案件 or 申請案件一覧・終了案件
      //// 6 処理済一覧・非活性案件
      //this.$refs.ApplyModal.popupFrom = '4'

      //this.$refs.ApplyModal.title = record.processDefinitionName
      //this.$refs.ApplyModal.component = record.component
      //this.$refs.ApplyModal.procInstId = record.processInstanceId
      //this.$refs.ApplyModal.taskId = record.id
      //this.$refs.ApplyModal.status = record.taskStatus

      //this.$refs.ApplyModal.handleOpen()
      this.$openWF(record.processInstanceId)
    },
    handleHistory(processInstanceId, title) {
      this.$refs.TrackModal.open(processInstanceId, title)
    },
    openPullback(record) {
      this.visiblePullback = true
      this.pullbackRecord = record
      this.pullbackTaskDefinitionKey = record.pullbackList[0].taskDefinitionKey
    },

    trackSrc(procInstId) {
      return (
        window._CONFIG['domianURL'] +
        '/flow/processTracking?processInstanceId=' +
        procInstId +
        '&locale=' +
        Vue.ls.get('Locale') +
        '&_t=' +
        Date.now()
      )
    },
    handlePullbackOk() {
      var that = this
      that.$confirm({
        title: that.$t('disp.warn'),
        content: that.$t('msg.flow.confirm.pullback'),
        centered: true,
        onOk() {
          that.visiblePullback = false

          if (that.loading) {
            return
          } else {
            that.loading = true
          }

          // 驳回节点对象
          var pullbackTarget = XEUtils.first(
            XEUtils.filter(
              that.pullbackRecord.pullbackList,
              (r) => r.taskDefinitionKey == that.pullbackTaskDefinitionKey
            )
          )

          postAction(that.url.pullback, {
            processInstanceId: that.pullbackRecord.processInstanceId,
            endDateTimestamp: that.pullbackRecord.endDateTimestamp,
            pullbackTarget: pullbackTarget,
          })
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.handleCancel()
                that.searchQuery(true, false)
              }
            })
            .finally(() => {
              that.loading = false
            })
        },
        onCancel() {},
      })
    },
    handlePullback(processInstanceId, endDateTimestamp, pullbackList) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      let pullbackTarget = {}
      if (pullbackList.length > 0) {
        pullbackTarget = pullbackList[0]
      }

      postAction(this.url.pullback, {
        processInstanceId: processInstanceId,
        endDateTimestamp: endDateTimestamp,
        pullbackTarget: pullbackTarget,
      })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleCancel(processInstanceId, endDateTimestamp) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.cancel, { processInstanceId: processInstanceId, endDateTimestamp: endDateTimestamp })
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    callbackAfterSearchQuery() {
      this.refresh++
    },
  },
}
</script>
<style lang="less" scoped>
.pullbackTarget {
  display: inline-block;
  background: #f8f8f8;
  padding: 4px 7px 3px 8px;
  font-size: 14px;
  margin-right: 6px;
  margin-bottom: 6px;
  border-radius: 1px;
  cursor: pointer;
  //min-width: 100px;
  text-align: center;
  transition: all 0.3s;
  min-width: 61px;
  position: relative;

  i {
    font-size: 12px;
    position: absolute;
    top: -4px;
    right: -4px;
    opacity: 0;
    transition: all 0.3s;
  }

  &.active {
    color: var(--color-primary-6);
    background: var(--color-primary-1);

    //.num {
    //  color: green !important;
    //}

    i {
      opacity: 1;
    }
  }

  &:hover {
    background: var(--color-primary-1);
  }
}

.track-wrapper {
  margin-top: 14px;
  height: calc(50vh - 93px);
  overflow: auto;
  background: rgba(255, 255, 255, 5%);
  border-radius: 0px;
  padding: 18px 16px 18px 20px;
  width: 350px;
  height: 421px;
  max-height: calc(100vh - 110px);
  background: white;
}

.track-wrapper.graph {
  background-image: linear-gradient(
      0deg,
      transparent 14px,
      rgba(204, 204, 204, 0.2) 14.5px,
      rgba(204, 204, 204, 0.2) 15px,
      transparent 15.1px,
      transparent 29px,
      rgba(204, 204, 204, 0.2) 29.5px,
      rgba(204, 204, 204, 0.2) 30px,
      transparent 30.1px,
      transparent 44px,
      rgba(204, 204, 204, 0.2) 44.5px,
      rgba(204, 204, 204, 0.2) 45px,
      transparent 45.1px,
      transparent 59px,
      rgba(204, 204, 204, 0.8) 60px
    ),
    linear-gradient(
      90deg,
      transparent 14px,
      rgba(204, 204, 204, 0.2) 14.5px,
      rgba(204, 204, 204, 0.2) 15px,
      transparent 15.1px,
      transparent 29px,
      rgba(204, 204, 204, 0.2) 29.5px,
      rgba(204, 204, 204, 0.2) 30px,
      transparent 30.1px,
      transparent 44px,
      rgba(204, 204, 204, 0.2) 44.5px,
      rgba(204, 204, 204, 0.2) 45px,
      transparent 45.1px,
      transparent 59px,
      rgba(204, 204, 204, 0.8) 60px
    );
  background-size: 60px 60px;
  width: 900px;
  padding: 0;
  background-position-y: -1px;
  border: 1px solid var(--color-tb-border);
}
</style>
